module.exports = function getResource(label, vars = []) {
    const resources = { addTheseTitle: 'Ajoutez-les pour moins de 15 $' };

    return resources[label];
};
